import { Controller } from "@hotwired/stimulus"

// INTENT: Fulfill a paid checkout as soon as Stripe redirects back, without writing to the database on the GET.
// EXPECTED OUTCOME: POSTs to confirm_checkout (retrying once). Once the purchase exists, reloads so the thank-you page
// renders the buyer's real next step (start studying, check inbox, sign in…) from their account state.
// CAVEAT/TRAP: If both attempts fail, show "still setting up" with a Check again link instead of spinning forever.
// The Stripe webhook and EnsurePurchasesCreatedJob still fulfill the order.
export default class extends Controller {
  static targets = ["pending", "fallback"]
  static values = { url: String, retryDelay: { type: Number, default: 2000 } }

  async connect() {
    if (await this.confirm()) return this.reload()

    await new Promise((resolve) => setTimeout(resolve, this.retryDelayValue))
    if (await this.confirm()) return this.reload()

    this.showFallback()
  }

  async confirm() {
    const csrfToken = document.head?.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || ""

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { accept: "application/json", "X-CSRF-Token": csrfToken }
      })
      if (!response.ok) return false

      const data = await response.json()
      return data.status === "ready"
    } catch {
      return false
    }
  }

  reload() {
    window.location.reload()
  }

  showFallback() {
    this.pendingTarget.hidden = true
    this.fallbackTarget.hidden = false
  }
}
